import { Departamento } from '../types/negocio/Departamento';
import api from './api';
import BaseService from './BaseService';

class DepartamentoService extends BaseService<Departamento> {
 
  constructor() {
    super('departamento', api);
  }
  
}

export const departamentoService = new DepartamentoService();